import useSortedVisibleFields from './useSortedVisibleFields';
import FieldContext from './FieldContext';
import FieldWrapper from './FieldWrapper';
import IndividualFieldRenderer from './IndividualFieldRenderer';
import { type AdditionalFieldConfig, type Field } from '@/lib/types';

type FieldRendererProps = {
  fields: Field[];
  disableCoachComments?: boolean;
};

const FieldRenderer = ({
  fields,
  disableCoachComments,
}: FieldRendererProps) => {
  const sortedVisibleFields = useSortedVisibleFields(fields);

  return sortedVisibleFields.map(field => (
    <FieldContext.Provider
      value={{
        ...field,
        additionalConfig: JSON.parse(
          field.additionalConfig as string,
        ) as AdditionalFieldConfig,
      }}
      key={field.id}
    >
      <FieldWrapper disableCoachComments={disableCoachComments ?? false}>
        <IndividualFieldRenderer />
      </FieldWrapper>
    </FieldContext.Provider>
  ));
};

export default FieldRenderer;
